import { createContext, useContext } from 'react'

import {
  AgoraRTCReactError,
  ICameraVideoTrack,
  IMicrophoneAudioTrack,
} from 'agora-rtc-react'

type LocalPlayerContextType = {
  localMicrophoneEnabled: boolean
  localCameraEnabled: boolean
  localScreenEnabled: boolean
  localMicrophoneTrack: IMicrophoneAudioTrack | null
  localCameraTrack: ICameraVideoTrack | null
  localMicrophoneError: AgoraRTCReactError | null
  localCameraError: AgoraRTCReactError | null
  currentCameraDeviceId: string | null
  currentMicrophoneDeviceId: string | null
  toggleLocalMicrophone: () => void
  toggleLocalCamera: () => void
  startLocalScreen: () => void
  stopLocalScreen: () => void
  switchCamera: (deviceId: string) => Promise<void>
  switchMicrophone: (deviceId: string) => Promise<void>
}

export const LocalPlayerContext = createContext<
  LocalPlayerContextType | undefined
>(undefined)

export const useLocalPlayer = () => {
  const context = useContext(LocalPlayerContext)
  if (!context) {
    throw new Error(
      'useLocalPlayerContext must be used within LocalPlayerProvider',
    )
  }
  return context
}
